import { Spinner, Text, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const WAIT_UNTIL_LOADING_MS = 200;
export function Loading({ label }: { label?: string }) {
	const { t } = useTranslation();

	const [isLoadingShown, setIsLoadingShown] = useState<boolean>(false);

	useEffect(() => {
		setTimeout(() => setIsLoadingShown(true), WAIT_UNTIL_LOADING_MS);
	}, []);

	return (
		<VStack width={'100%'} height={'100%'} justifyContent="center" alignItems="center" opacity={isLoadingShown ? 1 : 0} transition={'opacity 1s'}>
			<Spinner size="xl" color="black" />
			<Text color="black">{label || t('general.loading')}</Text>
		</VStack>
	);
}
